import React, { useState } from 'react';
import { TagIcon, UserCog, Activity, LogIn, FolderOpen, ChevronDown, FileText } from 'lucide-react';

const GlobalHeader = ({ role, vendorId, currentProject, projects, onProjectChange, onLogout, onOpenAudit, onOpenUserManagement, onOpenProjects, onOpenReports }) => {
  const [showProjectDropdown, setShowProjectDropdown] = useState(false);
  
  const title = role === 'admin' 
    ? 'لوحة تحكم الإدارة' 
    : role === 'superadmin' 
      ? 'لوحة تحكم المدير العام'
      : role === 'manager'
        ? 'لوحة التقارير'
        : 'بوابة البائعين';
      
  const userDisplay = role === 'admin' 
    ? 'مدير' 
    : role === 'superadmin' 
      ? 'مدير عام'
      : role === 'manager'
        ? 'مدير تقارير'
        : vendorId;

  return (
    <header className="flex justify-between items-center p-4 bg-white shadow-lg sticky top-0 z-10">
      <div className="text-xl font-bold text-indigo-600 flex items-center">
        <TagIcon className="w-6 h-6 mr-2 text-violet-500" />
        {title}
      </div>
      <div className="flex items-center space-x-3">
        
        {/* Project Selector - Show if user has multiple projects */}
        {projects && projects.length > 1 && (
          <div className="relative">
            <button
              onClick={() => setShowProjectDropdown(!showProjectDropdown)}
              className="flex items-center text-sm text-white bg-green-600 py-1.5 px-3 rounded-lg hover:bg-green-700 transition shadow-md"
            >
              <FolderOpen className="w-4 h-4 mr-1" />
              {currentProject ? currentProject.name : 'Select Project'}
              <ChevronDown className="w-4 h-4 ml-1" />
            </button>
            
            {showProjectDropdown && (
              <>
                <div 
                  className="fixed inset-0 z-20" 
                  onClick={() => setShowProjectDropdown(false)}
                />
                <div className="absolute right-0 mt-2 w-64 bg-white rounded-lg shadow-xl z-30 border border-gray-200">
                  <div className="py-2">
                    {projects.map((project) => (
                      <button
                        key={project.id}
                        onClick={() => {
                          onProjectChange(project);
                          setShowProjectDropdown(false);
                        }}
                        className={`w-full text-left px-4 py-2 hover:bg-gray-100 transition ${
                          currentProject && currentProject.id === project.id ? 'bg-indigo-50 text-indigo-600' : 'text-gray-700'
                        }`}
                      >
                        <div className="font-semibold">{project.name}</div>
                        {project.description && (
                          <div className="text-xs text-gray-500 mt-1">{project.description}</div>
                        )}
                      </button>
                    ))}
                  </div>
                </div>
              </>
            )}
          </div>
        )}
        
        {/* Current Project Display - Show if only one project */}
        {projects && projects.length === 1 && currentProject && (
          <div className="flex items-center text-sm text-gray-600 bg-gray-100 py-1.5 px-3 rounded-lg">
            <FolderOpen className="w-4 h-4 mr-1" />
            {currentProject.name}
          </div>
        )}
        
        {/* Projects Button - Visible only to Super Admin */}
        {role === 'superadmin' && (
          <button
            onClick={onOpenProjects}
            className="flex items-center text-sm text-white bg-green-600 py-1.5 px-3 rounded-lg hover:bg-green-700 transition shadow-md"
            title="إدارة المشاريع"
          >
            <FolderOpen className="w-4 h-4 mr-1" /> المشاريع
          </button>
        )}

        {/* User Management Button - Visible only to Super Admin */}
        {role === 'superadmin' && (
          <button
            onClick={onOpenUserManagement}
            className="flex items-center text-sm text-white bg-indigo-600 py-1.5 px-3 rounded-lg hover:bg-indigo-700 transition shadow-md"
            title="إدارة المستخدمين"
          >
            <UserCog className="w-4 h-4 mr-1" /> المستخدمين
          </button>
        )}
        
        {/* Reports Page Button - Visible to Super Admin and Manager */}
        {(role === 'superadmin' || role === 'manager') && (
          <button
            onClick={onOpenReports}
            className="flex items-center text-sm text-white bg-blue-600 py-1.5 px-3 rounded-lg hover:bg-blue-700 transition shadow-md"
            title="صفحة التقارير"
          >
            <FileText className="w-4 h-4 mr-1" /> التقارير
          </button>
        )}
        
        {/* Audit Log Button - Visible only to Super Admin */}
        {role === 'superadmin' && (
          <button
            onClick={onOpenAudit}
            className="flex items-center text-sm text-white bg-red-600 py-1.5 px-3 rounded-lg hover:bg-red-700 transition shadow-md"
            title="سجل التدقيق"
          >
            <Activity className="w-4 h-4 mr-1" /> سجل التدقيق
          </button>
        )}

        <p className="text-sm text-gray-600 hidden sm:block">
          مسجل الدخول كـ: <span className="font-semibold text-gray-800">{userDisplay}</span>
        </p>
        <button
          onClick={onLogout}
          className="flex items-center text-sm text-white bg-red-500 py-1.5 px-3 rounded-lg hover:bg-red-600 transition shadow-md"
        >
          <LogIn className="w-4 h-4 mr-1 transform rotate-180" /> تسجيل الخروج
        </button>
      </div>
    </header>
  );
};

export default GlobalHeader;
